
import { Button, Grid, TextField, Box, Typography, Checkbox, FormControlLabel, CircularProgress, Paper, Fade } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, login } from "../State/Auth/Action";
import { useDispatch, useSelector } from "react-redux";
import { Email, Lock, Close as CloseIcon } from "@mui/icons-material";


const Login = ({ handleClose, switchToRegister }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [touchedEmail, setTouchedEmail] = useState(false);
  const [touchedPassword, setTouchedPassword] = useState(false);
  const [isAgreeTC, setIsAgreeTC] = useState(false);

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const emailError = touchedEmail && (!email || !isValidEmail(email));
  const emailMessage = !email
    ? "Email is required"
    : !isValidEmail(email)
      ? "Enter a valid email address"
      : "";

  const passwordError = touchedPassword && (!password || password.length < 5);
  const passwordMessage = !password
    ? "Password is required"
    : password.length < 6
      ? "Password must be at least 6 characters"
      : "";

  const isFormValid = isValidEmail(email) && password.length >= 5;

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token && !auth.user) {
      dispatch(getUser(token));
    }
  }, [auth.user, dispatch]);

  useEffect(() => {
    if (auth.user?.role) {
      if (auth.user.role !== "CUSTOMER") {
        if (auth.user.role === "ADMIN") navigate("/admin/");
        else if (auth.user.role === "VENDOR") navigate("/vendor/");
        else if (auth.user.role === "EMPLOYEE") navigate("/employee/");

        window.location.reload();
        handleClose();
      }
    }
  }, [auth.user, navigate, handleClose]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const userData = {
      username: data.get("username"),
      password: data.get("password"),
    };
    if (!isAgreeTC) return;

    dispatch(login(userData));
  };

  return (
    <Fade in timeout={600}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '20vh',
          bgcolor: '#fff',
          pt: 3,
          pb: 3,
        }}
      >

        <Paper
          elevation={0}
          sx={{
            width: { xs: '95%', sm: '400px' },
            bgcolor: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
            overflow: 'visible',
            border: '1px solid #f1f5f9',
            background: 'linear-gradient(135deg, #ffffff 0%, #fafafa 100%)',
            position: 'relative'
          }}
        >
          {/* Close Button */}
          <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 9999 }}>
            <Button
              type="button"
              variant="text"
              size="small"
              color="inherit"
              fullWidth={false}
              disableRipple={false}
              disableElevation={false}
              disableFocusRipple={false}
              disableTouchRipple={false}
              focusVisibleClassName=""
              href=""
              target=""
              rel=""
              download=""
              startIcon=""
              endIcon=""
              children=""
              component="button"
              to=""
              replace={false}
              disabled={false}
              aria-label="Close login form"
              onClick={() => {
                handleClose();
              }}
              sx={{
                minWidth: 'auto',
                width: 40,
                height: 40,
                borderRadius: '50%',
                bgcolor: '#ffffff',
                color: '#374151',
                border: '2px solid #e2e8f0',
                cursor: 'pointer',
                pointerEvents: 'auto',
                '&:hover': {
                  bgcolor: '#f1f5f9',
                  color: '#1f2937',
                  transform: 'scale(1.05)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                },
                transition: 'all 0.2s ease-in-out',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                '&:focus': {
                  outline: '2px solid #3b82f6',
                  outlineOffset: '2px',
                },
              }}
            >
              <CloseIcon sx={{ fontSize: '1.25rem' }} />
            </Button>
          </Box>

          {/* Header Section */}
          <Box sx={{
            width: '100%',
            p: 4,
            textAlign: 'center',
            bgcolor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            position: 'relative',
            overflow: 'hidden'
          }}>
            {/* Decorative Elements */}
            <Box sx={{
              position: 'absolute',
              top: -20,
              right: -20,
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: 'rgba(55, 65, 81, 0.05)',
              zIndex: 1
            }} />
            <Box sx={{
              position: 'absolute',
              bottom: -30,
              left: -30,
              width: 60,
              height: 60,
              borderRadius: '50%',
              bgcolor: 'rgba(55, 65, 81, 0.03)',
              zIndex: 1
            }} />

            <Typography
              variant="h5"
              sx={{
                fontWeight: '800',
                color: '#374151',
                textTransform: 'uppercase',
                fontSize: '1.375rem',
                letterSpacing: '1.5px',
                mb: 1,
                position: 'relative',
                zIndex: 2
              }}
            >
              Inarifashion
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#6b7280',
                fontSize: '0.875rem',
                fontWeight: '500',
                position: 'relative',
                zIndex: 2
              }}
            >
              Premium Fashion & Lifestyle
            </Typography>
          </Box>

          {/* Login Form Section */}
          <Box sx={{ p: 4 }}>
            <Typography
              variant="h6"
              sx={{
                mb: 2,
                fontWeight: '700',
                textAlign: 'center',
                color: '#1f2937',
                fontSize: '1.25rem'
              }}
            >
              Login
            </Typography>

            <Typography
              variant="body2"
              sx={{
                mb: 4,
                textAlign: 'center',
                color: '#6b7280',
                fontSize: '0.875rem',
                lineHeight: 1.5
              }}
            >
              Enter your credentials to access your account
            </Typography>

            <form onSubmit={handleSubmit}>
              <Grid container spacing={3} direction="column">
                {/* Email Input */}
                <Grid item xs={12}>
                  <TextField
                    required
                    id="username"
                    name="username"
                    label="Email Address"
                    type="email"
                    fullWidth
                    autoComplete="email"
                    placeholder="Enter your email"
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={() => setTouchedEmail(true)}
                    error={emailError}
                    helperText={emailError ? emailMessage : ""}
                    InputProps={{
                      startAdornment: <Email sx={{ mr: 1.5, color: '#9ca3af', fontSize: '1.25rem' }} />,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontSize: '0.875rem',
                        bgcolor: '#fafafa',
                        '&:hover': {
                          bgcolor: '#f8fafc',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#d1d5db',
                            borderWidth: '2px',
                          },
                        },
                        '&.Mui-focused': {
                          bgcolor: '#ffffff',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#374151',
                            borderWidth: '2px',
                          },
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '0.875rem',
                        color: '#6b7280',
                        fontWeight: '500',
                      },
                    }}
                  />
                </Grid>

                {/* Password Input */}
                <Grid item xs={12}>
                  <TextField
                    required
                    id="password"
                    name="password"
                    type="password"
                    label="Password"
                    fullWidth
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    onChange={(e) => setPassword(e.target.value)}
                    onBlur={() => setTouchedPassword(true)}
                    error={passwordError}
                    helperText={passwordError ? passwordMessage : ""}
                    InputProps={{
                      startAdornment: <Lock sx={{ mr: 1.5, color: '#9ca3af', fontSize: '1.25rem' }} />,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '12px',
                        fontSize: '0.875rem',
                        bgcolor: '#fafafa',
                        '&:hover': {
                          bgcolor: '#f8fafc',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#d1d5db',
                            borderWidth: '2px',
                          },
                        },
                        '&.Mui-focused': {
                          bgcolor: '#ffffff',
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#374151',
                            borderWidth: '2px',
                          },
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontSize: '0.875rem',
                        color: '#6b7280',
                        fontWeight: '500',
                      },
                    }}
                  />
                </Grid>

                {/* Terms Checkbox */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onClick={() => setIsAgreeTC(!isAgreeTC)}
                        value={isAgreeTC}
                        name="agreeTerms"
                        sx={{
                          color: '#374151',
                          '&.Mui-checked': {
                            color: '#374151',
                          },
                          '& .MuiSvgIcon-root': {
                            fontSize: '1.25rem',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: '0.75rem',
                          color: '#6b7280',
                          lineHeight: 1.5
                        }}
                      >
                        By continuing, I agree to the{' '}
                        <a href="#" style={{ color: '#374151', textDecoration: 'none', fontWeight: '700' }}>
                          Terms of Use
                        </a>{' '}
                        &{' '}
                        <a href="#" style={{ color: '#374151', textDecoration: 'none', fontWeight: '700' }}>
                          Privacy Policy
                        </a>{' '}
                        and I am above 18 years old.
                      </Typography>
                    }
                    sx={{ mt: 0, mb: 3, alignItems: 'flex-start' }}
                  />

                  {/* Submit Button */}
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={auth.isLoading || !isFormValid || !isAgreeTC}
                    sx={{
                      py: 2,
                      bgcolor: '#374151',
                      borderRadius: '12px',
                      '&:hover': {
                        bgcolor: '#1f2937',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 8px 25px rgba(55, 65, 81, 0.4)',
                      },
                      color: '#fff',
                      fontWeight: '700',
                      textTransform: 'uppercase',
                      fontSize: '0.875rem',
                      letterSpacing: '1px',
                      transition: 'all 0.3s ease-in-out',
                      boxShadow: '0 4px 15px rgba(55, 65, 81, 0.3)',
                    }}
                  >
                    {auth.isLoading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Login"}
                  </Button>
                </Grid>

              </Grid>
            </form>

            {/* Register Link */}
            {/* <Typography
              variant="body2"
              sx={{
                mt: 3,
                textAlign: 'center',
                fontSize: '0.875rem',
                color: '#6b7280'
              }}
            >
              Don't have an account?{' '}
              <span
                style={{
                  color: '#374151',
                  textDecoration: 'none',
                  cursor: "pointer",
                  fontWeight: '700',
                  borderBottom: '1px solid #d1d5db'
                }}
                onClick={switchToRegister}
              >
                Register
              </span>
            </Typography> */}

            {/* Help Link */}
            <Typography
              variant="caption"
              sx={{
                mt: 2,
                textAlign: 'center',
                display: 'block',
                fontSize: '0.75rem',
                color: '#9ca3af'
              }}
            >
              Having trouble logging in?{' '}
              <a
                href="#"
                style={{
                  color: '#374151',
                  textDecoration: 'none',
                  fontWeight: '700',
                  borderBottom: '1px solid #d1d5db',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    borderBottomColor: '#374151',
                  }
                }}
              >
                Get help
              </a>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Fade>
  );
};

export default Login;
